<div class="dialog-container-wrapper">

    <div class="image-wrapper">

        <img *ngIf="data?.mediaType === proofTypes.IMAGE" [src]="data.mediaUrl" alt="Expanded Media" />


        <video  *ngIf="data?.mediaType === proofTypes.VIDEO" [src]="data.mediaUrl" controls>

            Your browser does not support the video tag.
        </video>

                <iframe *ngIf="data?.mediaType === proofTypes.DOCUMENT"
            src="https://flowing-profile-pictures-hml.s3-sa-east-1.amazonaws.com/campaign/682750ec86da5f543f86a811/challenge/6827518586da5f543f86a8c7/user/678a82c4debdd845719ebdf3/proof/064eb353-aae3-47a0-a02c-33c5dd22bdf3_0.pdf"
            allow="fullscreen"
            class="w-100 h-100 border-0">
            </iframe>

           
    </div>

    <mat-dialog-actions align="center">
        <button class="btn btn-outline-primary me-3" (click)="closeDialog()">Voltar</button> 
        <button
        (click)="downloadFileFromUrl(data?.mediaUrl)" 
        class="btn btn-primary"> Fazer Download</button>
    </mat-dialog-actions>
</div>